// GDPR cookie consent, behaviour ported from the legacy site (localStorage flag).
import { find } from './dom';

interface Preferences {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
}

export function initCookieConsent(): void {
  const overlay = find('cookieConsent');
  if (!overlay) return;

  if (localStorage.getItem('cookieConsent')) return;
  overlay.hidden = false;

  const close = (): void => {
    overlay.style.transition = 'opacity 0.3s';
    overlay.style.opacity = '0';
    setTimeout(() => {
      overlay.hidden = true;
    }, 300);
  };

  const store = (prefs: Preferences): void => {
    localStorage.setItem('cookieConsent', JSON.stringify(prefs));
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    close();
  };

  const checked = (id: string): boolean => (find<HTMLInputElement>(id)?.checked ?? false);

  find('consentAccept')?.addEventListener('click', () => store({ essential: true, analytics: true, marketing: true }));
  find('consentReject')?.addEventListener('click', () => store({ essential: true, analytics: false, marketing: false }));
  find('consentSelected')?.addEventListener('click', () =>
    store({ essential: true, analytics: checked('analyticsCookies'), marketing: checked('marketingCookies') }));
  find('consentClose')?.addEventListener('click', close);
}
